<div class="p-4 side open" style="left: 0px; top: 60px; margin-left: -15px">
  <div class="row justify-content-center mt-3">
    <button [ngClass]="'btn btn-primary btn-icon-open'" routerLink="/settings/member-removal"
      routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }">
      <i class="fa-regular fa-chart-tree-map fa-lg"></i>
      <a style="font-size: 16px; text-transform: capitalize; padding-left: 8px">Conta</a>
    </button>
  </div>

  <!-- Configuração de Relatórios -->
  <div class="row justify-content-center mt-3" *appCan="'report_settings:read'">
    <button [ngClass]="'btn btn-primary btn-icon-open'" routerLink="/settings/report" routerLinkActive="active-link"
      [routerLinkActiveOptions]="{ exact: true }">
      <i class="fa-regular fa-circle-user fa-lg"></i>
      <a style="font-size: 16px; text-transform: capitalize; padding-left: 8px">Relatórios</a>
    </button>
  </div>

  <!-- Dimensões -->
  <div class="row justify-content-center mt-3" *appCan="'dimensions:read'">
    <button [ngClass]="'btn btn-primary btn-icon-open'" routerLink="/settings/dimension" routerLinkActive="active-link"
      [routerLinkActiveOptions]="{ exact: true }">
      <i class="fa-regular fa-chart-tree-map fa-lg"></i>
      <a style="font-size: 16px; text-transform: capitalize; padding-left: 8px">Dimensões</a>
    </button>
  </div>

  <!-- Configuração de Tarefas Pendentes -->
  <div class="row justify-content-center mt-3" *appCan="'pending_tasks_settings:read'">
    <button [ngClass]="'btn btn-primary btn-icon-open'" routerLink="/settings/pending-tasks"
      routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }">
      <i class="fa-regular fa-list-timeline fa-lg"></i>
      <a style="font-size: 16px; text-transform: capitalize; padding-left: 6px">Tarefas Pendentes</a>
    </button>
  </div>

  <!-- Mapas Off-line -->
  <div class="row justify-content-center mt-3" *appCan="'offline_maps:read'">
    <button [ngClass]="'btn btn-primary btn-icon-open'" routerLink="/settings/offline-maps"
      routerLinkActive="active-link">
      <i class="fa-regular fa-book-atlas fa-lg"></i>
      <a style="font-size: 16px; text-transform: capitalize; padding-left: 8px">Mapas Off-line</a>
    </button>
  </div>

  <!-- Notificações para o aplicativo -->
  <div class="row justify-content-center mt-3" *appCan="'app_notifications:read'">
    <button [ngClass]="'btn btn-primary btn-icon-open'" routerLink="/settings/global-notification"
      routerLinkActive="active-link">
      <i class="fa-regular fa-bell fa-lg"></i>
      <a style="font-size: 16px; text-transform: capitalize; padding-left: 8px">Notificação App</a>
    </button>
  </div>

  <!-- Sinalizações -->
  <div class="row justify-content-center mt-3" *appCan="'organization:update'">
    <button [ngClass]="'btn btn-primary btn-icon-open'" routerLink="/settings/signaling-preferences"
      routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }">
      <i class="fa-regular fa-triangle-exclamation fa-lg"></i>
      <a style="font-size: 16px; text-transform: capitalize; padding-left: 8px">Sinalizações</a>
    </button>
  </div>

  <!-- Notificações -->
  <div class="row justify-content-center mt-3" *appCan="'notifications:read'">
    <button [ngClass]="'btn btn-primary btn-icon-open'" routerLink="/settings/logs" routerLinkActive="active-link">
      <i class="fa-regular fa-bells fa-lg" style="width: 30px"></i>
      <a style="font-size: 16px; text-transform: capitalize">{{ 'Notificações' }}</a>
    </button>
  </div>

  <!-- Grupos de Compartilhamento -->
  <div class="row justify-content-center mt-3" *appCan="'sharing_groups:read'">
    <button [ngClass]="'btn btn-primary btn-icon-open'" routerLink="/settings/sharing" routerLinkActive="active-link"
      [routerLinkActiveOptions]="{ exact: true }">
      <i class="fa-regular fa-message-lines fa-lg"></i>
      <a style="font-size: 16px; text-transform: capitalize; padding-left: 8px">{{ 'Compartilhamento' }}</a>
    </button>
  </div>

  <!-- Configuração de Ouvidoria -->
  <div class="row justify-content-center" style="margin-top: 16px" *appCan="'ombudsman_settings:read'">
    <button [ngClass]="'btn btn-primary btn-icon-open'" routerLink="/settings/contact-us" routerLinkActive="active-link"
      [routerLinkActiveOptions]="{ exact: true }">
      <i class="fa-sharp fa-regular fa-phone-volume" style="transform: rotate(45deg)"></i>
      <a style="font-size: 16px; text-transform: capitalize; padding-left: 8px">Ouvidoria</a>
    </button>
  </div>

  <!-- SLA -->
  <div class="row justify-content-center mt-3" *appCan="'sla_rules:read'">
    <button [ngClass]="'btn btn-primary btn-icon-open'" routerLink="/settings/sla-rules" routerLinkActive="active-link"
      [routerLinkActiveOptions]="{ exact: true }">
      <i class="fa-regular fa-clock fa-lg"></i>
      <a style="font-size: 16px; text-transform: capitalize; padding-left: 8px">SLA</a>
    </button>
  </div>

  <!-- Garantia -->
  <div class="row justify-content-center mt-3" *appCan="'warranty:read'">
    <button [ngClass]="'btn btn-primary btn-icon-open'" routerLink="/settings/warranty" routerLinkActive="active-link"
      [routerLinkActiveOptions]="{ exact: true }">
      <i class="fa-regular fa-shield-check fa-lg"></i>
      <a style="font-size: 16px; text-transform: capitalize; padding-left: 8px">Garantia</a>
    </button>
  </div>

  <!-- Duplicidade -->
  <div class="row justify-content-center mt-3" *appCan="'organization:update'">
    <button [ngClass]="'btn btn-primary btn-icon-open'" routerLink="/settings/duplicate" routerLinkActive="active-link"
      [routerLinkActiveOptions]="{ exact: true }">
      <i class="fa-regular fa-clone fa-lg"></i>
      <a style="font-size: 16px; text-transform: capitalize; padding-left: 8px">Duplicidade</a>
    </button>
  </div>

  <div class="sidebar-footer">
    <img [src]="org?.imageURL ?? 'assets/icons/camera.svg'" class="org-img" />
    <p class="org-name">{{ org?.name ?? 'Organização não informada' }}</p>
  </div>

</div>